package com.islamicmedia.site.components

import androidx.compose.runtime.*
import com.islamicmedia.shared.presentation.MediaCheckerViewModel
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AboutScreen(viewModel: MediaCheckerViewModel) {
    var foundingMembers by remember { mutableStateOf<List<String>>(emptyList()) }

    LaunchedEffect(Unit) {
        foundingMembers = viewModel.fetchFoundingMembers()
    }

    Div(attrs = {
        style {
            maxWidth(560.px)
            property("margin", "0 auto")
            padding(32.px, 24.px)
            property("text-align", "center")
        }
    }) {
        // About Us heading
        Div(attrs = {
            style {
                fontSize(11.px)
                fontWeight(600)
                color(Gray500)
                letterSpacing(1.px)
                property("text-transform", "uppercase")
                marginBottom(12.px)
            }
        }) { Text("About Us") }

        Div(attrs = {
            style {
                fontSize(14.px)
                color(Gray700)
                lineHeight(1.6.em)
                marginBottom(24.px)
            }
        }) {
            Text(
                "Fitrah Filter helps Muslim parents make informed decisions about media their children consume. " +
                "Using AI-assisted analysis combined with Islamic scholarship and developmental research, we provide " +
                "thoughtful, faith-informed guidance on movies, TV shows, games, and more."
            )
        }

        // Disclaimer
        Div(attrs = {
            style {
                fontSize(11.px)
                fontWeight(600)
                color(Gray500)
                letterSpacing(1.px)
                property("text-transform", "uppercase")
                marginBottom(12.px)
            }
        }) { Text("Disclaimer") }

        Div(attrs = {
            style {
                fontSize(13.px)
                color(Gray600)
                lineHeight(1.6.em)
                marginBottom(24.px)
            }
        }) {
            Text(
                "Our analyses are AI-assisted and intended as a helpful starting point, not a substitute for " +
                "personal judgment or qualified scholarly consultation. Always review content yourself before sharing it with your family."
            )
        }

        // Founding Members (only shown when list is non-empty)
        if (foundingMembers.isNotEmpty()) {
            Div(attrs = {
                style {
                    fontSize(11.px)
                    fontWeight(600)
                    color(Gray500)
                    letterSpacing(1.px)
                    property("text-transform", "uppercase")
                    marginBottom(8.px)
                }
            }) { Text("Founding Members") }

            Div(attrs = {
                style {
                    fontSize(13.px)
                    color(Gray600)
                    marginBottom(16.px)
                }
            }) { Text("A heartfelt thank you to those who believed in this project from the start.") }

            Div(attrs = {
                style {
                    property("background", AccentLight)
                    property("border", "1px solid rgba(14,124,123,0.3)")
                    borderRadius(16.px)
                    padding(20.px)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(10.px)
                    alignItems(AlignItems.Center)
                }
            }) {
                foundingMembers.forEach { name ->
                    Div(attrs = {
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            gap(8.px)
                            property("justify-content", "center")
                        }
                    }) {
                        Span(attrs = { style { fontSize(18.px) } }) { Text("⭐") }
                        Span(attrs = {
                            style {
                                fontSize(15.px)
                                fontWeight(500)
                                color(Gray900)
                            }
                        }) { Text(name) }
                        Span(attrs = { style { fontSize(18.px) } }) { Text("⭐") }
                    }
                }
            }

            Div(attrs = { style { marginBottom(24.px) } })
        }

        // Credits — the Flaticon licence needs a visible credit for the KIDZONE icons.
        Div(attrs = {
            style {
                fontSize(11.px)
                fontWeight(600)
                color(Gray500)
                letterSpacing(1.px)
                property("text-transform", "uppercase")
                marginBottom(12.px)
            }
        }) { Text("Credits") }

        Div(attrs = {
            style {
                fontSize(12.px)
                color(Gray600)
                lineHeight(1.6.em)
                marginBottom(24.px)
            }
        }) {
            Div { Text("KIDZONE icons by Magnific from flaticon.com") }
            Div { Text("KIDZONE title font: Jumpman by Neale Davidson (SIL OFL)") }
        }

        // Footer
        Div(attrs = {
            style {
                fontSize(12.px)
                color(Gray400)
                marginTop(8.px)
            }
        }) { Text("Made with care for the Ummah") }
    }
}
